export const SITE_URL = "https://scandicdev.com";
export const BRAND_NAME = "ScandicDev";

export const homeSeo = {
  path: "/",
  title: "KI-Agenten für Unternehmen in Deutschland | ScandicDev",
  description:
    "ScandicDev entwickelt KI-Agenten für Unternehmen im deutschen Mittelstand: DSGVO-konforme Automatisierung für Telefon, E-Mail, Dokumente und Workflows.",
};

export const englishHomeSeo = {
  path: "/en",
  title: "AI Agents for Companies in Germany | ScandicDev",
  description:
    "ScandicDev builds AI agents for companies that automate phone, email, documents, and workflows with a pragmatic delivery model.",
};

export const legalPageSeo = {
  "/impressum": {
    title: "Impressum | ScandicDev",
    description: "Impressum und Anbieterkennzeichnung von ScandicDev.",
    language: "de",
  },
  "/datenschutz": {
    title: "Datenschutzerklärung | ScandicDev",
    description: "Datenschutzerklärung von ScandicDev mit Informationen zur Verarbeitung personenbezogener Daten.",
    language: "de",
  },
  "/ki-ethik": {
    title: "KI-Ethik-Kodex | ScandicDev",
    description: "KI-Ethik-Kodex von ScandicDev für verantwortungsvolle Automatisierung und den Einsatz von KI-Systemen.",
    language: "de",
  },
  "/en/impressum": {
    title: "Imprint | ScandicDev",
    description: "Legal notice and provider information for ScandicDev.",
    language: "en",
  },
  "/en/datenschutz": {
    title: "Privacy Policy | ScandicDev",
    description: "Privacy policy for ScandicDev with information on the processing of personal data.",
    language: "en",
  },
  "/en/ki-ethik": {
    title: "AI Code of Ethics | ScandicDev",
    description: "AI code of ethics for ScandicDev and its responsible use of automation and AI systems.",
    language: "en",
  },
};

export const canonicalPublicPaths = [
  "/",
  "/impressum",
  "/datenschutz",
  "/ki-ethik",
  "/ki-agenten-fuer-unternehmen",
  "/ki-telefonassistent",
  "/ki-email-automation",
  "/ki-dokumentenverarbeitung",
  "/branchen/logistik",
  "/branchen/kanzlei",
  "/branchen/arztpraxis",
  "/en",
  "/en/impressum",
  "/en/datenschutz",
  "/en/ki-ethik",
];

export function getCanonicalUrl(path) {
  return path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}

export function getLanguageFromPath(pathname) {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "de";
}

export function getHomePath(language) {
  return language === "en" ? "/en" : "/";
}

export function getLegalPath(slug, language) {
  return language === "en" ? `/en/${slug}` : `/${slug}`;
}

export function getAlternateLanguagePath(pathname) {
  if (pathname === "/") {
    return "/en";
  }

  if (pathname === "/en") {
    return "/";
  }

  if (pathname.startsWith("/en/")) {
    return pathname.replace("/en", "");
  }

  if (pathname === "/impressum" || pathname === "/datenschutz" || pathname === "/ki-ethik") {
    return `/en${pathname}`;
  }

  return null;
}
